import { useMemo } from 'react';
import { useWindowSize } from 'react-use';

export default function useMedia() {
  const { width } = useWindowSize();

  const isMobile = useMemo(() => width >= 0 && width <= 480, [width]);
  const isTablet = useMemo(() => width >= 481 && width <= 768, [width]);
  const isSmallLaptop = useMemo(() => width >= 769 && width <= 1024, [width]);
  const isLaptop = useMemo(() => width >= 1025 && width <= 1280, [width]);
  const isLargeLaptop = useMemo(() => width >= 1281, [width]);

  const isBelowTablet = useMemo(() => width < 481, [width]);
  const isBelowSmallLaptop = useMemo(() => width < 769, [width]);
  const isBelowLaptop = useMemo(() => width < 1025, [width]);
  const isBelowLargeLaptop = useMemo(() => width < 1281, [width]);

  const isAboveMobile = useMemo(() => width > 480, [width]);
  const isAboveTablet = useMemo(() => width > 768, [width]);
  const isAboveSmallLaptop = useMemo(() => width > 1024, [width]);
  const isAboveLaptop = useMemo(() => width > 1280, [width]);

  return {
    isMobile,
    isTablet,
    isSmallLaptop,
    isLaptop,
    isLargeLaptop,
    isBelowTablet,
    isBelowSmallLaptop,
    isBelowLaptop,
    isBelowLargeLaptop,
    isAboveMobile,
    isAboveTablet,
    isAboveSmallLaptop,
    isAboveLaptop,
  };
}
